exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../resources/todo_drophint_bw.svg"));
var ___CSS_LOADER_URL___1___ = getUrl(require("../resources/todo_drophint.svg"));
// Module
exports.push([module.id, "html[dir] ._3ddYyqUqT1nLd_whsRw_KK{background-image:url(" + ___CSS_LOADER_URL___0___ + ")}html[dir] ._3CKteUu-pW7r9AftA8ucaN{background-image:url(" + ___CSS_LOADER_URL___1___ + ")}", ""]);
// Exports
exports.locals = {
	"taskDropHintIconBase": "_3ddYyqUqT1nLd_whsRw_KK",
	"taskDropHintIconActive": "_3CKteUu-pW7r9AftA8ucaN"
};